<template>
  <models
    :showmodel="showeditcompany"
    :title="title"
    :canceltext="canceltext"
    :confirmtext="confirmtext"
    :needcancel="needcancel"
    @confirm="confirmedit"
    @closemodel="closeeditcompany"
    class="ifeditename"
  >
    <div class="maincontent">
      <el-row>
        <el-col :span="6">
          <div class="labelname"><span>公司名称：</span></div>
        </el-col>
        <el-col :span="18">
          <el-input size="small" v-model="CompanyName" clearable></el-input>
        </el-col>
      </el-row>
    </div>
  </models>
</template>
<script>
import Models from "@/components/Models/index.vue";
export default {
  props: {
    showeditcompany: {
      type: Boolean,
    },
    row: {
      type: Object,
    },
    title: {
      type: String,
    },
    canceltext: {
      type: String,
      default: "取消",
    },
    confirmtext: {
      type: String,
      default: "确定",
    },
    needcancel: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      CompanyName: this.row.CompanyName,
    };
  },
  watch: {
    row: function (val) {
      this.CompanyName = val.CompanyName;
      this.row = val;
    },
  },
  components: {
    Models,
  },
  methods: {
    confirmedit() {
      let data = {
        CompanyName: this.CompanyName,
        UserId: this.row.UserId,
      };
      this.$store.dispatch("user/setchannelcompany", { ...data }).then((res) => {
        if (res.RetCode == 0) {
          this.$message.success("修改成功");
          this.closeeditcompany();
        } else {
          this.$message.error( res.Message || "修改失败");
          this.closeeditcompany();
        }
      });
    },
    closeeditcompany() {
      this.$emit("closeeditcompany");
    },
  },
};
</script>
<style lang="scss" scoped>
.ifeditename {
  ::v-deep .el-dialog {
    width: 450px;
    height: 250px;
  }
  ::v-deep .el-dialog__header {
    padding: 0;
  }
  ::v-deep .el-dialog__footer {
    padding: 0;
  }
  ::v-deep .el-dialog__body {
    height: 80px;
  }
  ::v-deep .el-table::before {
    background-color: #fff;
  }
  .labelname {
    min-height: 32px;
    line-height: 32px;
    text-align: center;
  }
  .maincontent {
    margin-top: 20px;
  }
  .warningtitle {
    height: 40px;
    margin-bottom: 20px;
    background-color: rgba(228, 229, 241);
    line-height: 40px;
    color: rgb(102, 102, 102);
    font-size: 14px;
    .warningcontent {
      margin-left: 20px;
    }
  }
}
</style>